import { FC, useEffect, useState, useMemo } from 'react';
import { HarmReportDetailsProps } from './harmReports.type';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createHarmReportConfig } from '../../component/reportDetails/harmReportConfig';
import { getHarmReportsKebabOptions } from './harmReportesHelper';
import { ReportService } from '../../service/reportService';
import Loading from '../../assets/loading/loading';
import ModalComponent from '../../component/modal/modal';
import {
  HarmReport,
  GetPlayerInterventionCountQueryParams,
  GetPlayerInterventionCountResponse,
} from '@inplay/models';

export const HarmReportDetails: FC<HarmReportDetailsProps> = (props) => {
  const { harmReport } = props;
  const reportService = useMemo(() => new ReportService(), []);

  const [data, setData] = useState<HarmReport>(harmReport);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!harmReport.createdBy) {
      setLoading(false);
      return;
    }

    const ac = new AbortController();

    (async () => {
      try {
        setLoading(true);

        const query: GetPlayerInterventionCountQueryParams = {
          venueBranchId: data.venueBranch.id,
          currentDate: data.createdAt.toString(),
        };

        const response: GetPlayerInterventionCountResponse =
          await reportService.getPlayerInterventionCount(
            data.playerProfile.id,
            query,
          );
        console.log(response);

        harmReport.playerDetails.gambling.interventionsOffered =
          response.interventionOffered;
        harmReport.playerDetails.gambling.interventionsRequested =
          response.interventionRequested;

        setData(harmReport);
      } catch (err: unknown) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();

    return () => ac.abort();
  }, [harmReport.createdBy]);

  if (loading)
    return (
      <ModalComponent
        onToggle={props.closeHarmReportDetails}
        open={true}
        title=""
        isShowClose={true}
        footerHidden
        dialogClassName="w-full max-w-[900px] h-[90vh] overflow-hidden"
        headerClassName="!py-7 !pb-3 h-[80px] items-center !mx-0 px-10"
      >
        <div className="flex justify-center items-center h-[calc(90vh-80px)]">
          <Loading />
        </div>
      </ModalComponent>
    );

  const config = createHarmReportConfig(data);

  return (
    <ReportDetails
      config={config}
      onClose={props.closeHarmReportDetails}
      onReviewAndSign={props.handleReviewAndSignClick}
      kebabOptions={getHarmReportsKebabOptions(data, null, 0)
        .filter((o) => o.label !== 'View')
        .map((o) => ({
          label: o.label,
          optionKey: o.label,
        }))}
      onKebabAction={props.onKebabAction}
    />
  );
};
